export default "__VITE_ASSET__Bhl3XFdi__"